import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { generateSearchPath } from '../../../../utils/urlHelpers/boats';
import { getRadiuses, locationParam } from '../../utils/radiusSearch';
import { syncTranslationElements } from '../../../../tppServices/translations/intlManager';
import { setLocationText } from '../../../../store/actions';
import { getLocationTextField } from '../Filter/FilterSuggestLocation/filterSuggestionUtils';
import './styles.css';

const FilterRadiusDropdown = ({ urlParams = {}, history, filterState = {} }) => {
  const [newRadius, setNewRadius] = useState(urlParams.radius);
  const radiuses = getRadiuses();
  const { formatMessage: t, messages } = syncTranslationElements();
  const dispatch = useDispatch();

  useEffect(() => {
    setNewRadius(filterState.radius);
  }, [filterState.radius]);

  const updateLocationText = (radiusValue) => {
    const typeaheadInput = getLocationTextField();

    if (!filterState.placeId && radiusValue && radiusValue !== '0') {
      const myLocationText = t(messages.radius.myLocation);
      dispatch(setLocationText(myLocationText));
    } else {
      if (!filterState.placeId) {
        dispatch(setLocationText(''));
        if (typeaheadInput) {
          typeaheadInput.value = '';
          const event = new Event('input', { bubbles: true });
          typeaheadInput.dispatchEvent(event);
        }
      }
    }
  };

  const handleOnChangeDistance = (e) => {
    const value = e.target.value;
    setNewRadius(value);

    updateLocationText(value);

    const isValidfilterState = Object.keys(filterState).length > 0;
    const pathParams = isValidfilterState ? filterState : urlParams;
    const newPathParams = {
      ...pathParams,
      radius: value,
      ...locationParam
    };

    const url = generateSearchPath(newPathParams, pathParams, true);
    history.push(url);
  };

  useEffect(() => {
    updateLocationText(newRadius);
  }, [newRadius]);

  return (
    <select
      className="filter-radius-dropdown"
      value={newRadius}
      onChange={handleOnChangeDistance}
    >
      {radiuses.map((obj) => (
        <option key={obj.value} value={obj.value}>
          {obj.label}
        </option>
      ))}
    </select>
  );
};

FilterRadiusDropdown.propTypes = {
  urlParams: PropTypes.object,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  filterState: PropTypes.object
};

export default FilterRadiusDropdown;
